import { Box, Typography } from "@mui/material";
import bgImg from "../../assets/img/3161025.jpg";
import HomeSearch from "../../components/filters/HomeSearch";
import logo from "../../assets/img/cm_logo_white.png";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const HeroSection = () => {
  const { pathname } = useLocation();
  const isNotHomePage = pathname !== "/";

  return (
    <Box
      sx={{
        backgroundImage: `url(${bgImg})`,
        position: "relative",
        width: "100%",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 2, md: 3 },
        py: 10,
      }}
    >
      <motion.div
        initial={{ y: -10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 10, opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.5 }}
      >
        <Box sx={{ width: { xs: 200, xl: 280 },background:"#c9dbff" }}>
          <img src={logo} alt="logo" style={{ width: "100%" }} />
        </Box>
      </motion.div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <motion.div
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 10, opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.4 }}
        >
          <Typography
            className="intro animationName"
            data-text="GET YOUR DREAM JOB TODAY"
            sx={{
              textAlign: "center",
              fontSize: { xs: "20px", md: "24px", xl: "40px" },
              color: "#fff",
              position: "relative",
              fontStyle: "normal",
              letterSpacing: { xs: 0, sm: "1px", md: "3px" },
            }}
          >
            GET YOUR DREAM JOB TODAY
          </Typography>
        </motion.div>
      </Box>
      {!isNotHomePage && (
        <Box sx={{ maxWidth: { xs: 500, md: 800 }, mt: { xs: 2, md: 3 } }}>
          <motion.div
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
            transition={{ duration: 0.2, delay: 0.3 }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: "16px", md: "20px" },
                textAlign: "center",
                px: { xs: 2, md: 0 },
              }}
            >
              TOKUTEI, KATUDO VISA များကို အခမဲ့ အလုပ်အကိုင်မိတ်ဆက်ပေးနေတဲ့အတွက် အကြိုက်ဆုံး အလုပ်ကို အမြန်ဆုံး ရွေးချယ်လိုက်ကြရအောင်            </Typography>
          </motion.div>
        </Box>
      )}
      <Box
        sx={{
          width: "100%",
          height: "100px",
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          bottom: 0,
          mt: { xs: 1, md: 2 },
          px: { xs: 2, md: 0 },
        }}
      >
        <motion.div
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 10, opacity: 0 }}
            transition={{ duration: 0.2, delay: 0.8 }}
          >
          <HomeSearch />
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;
